import { render, staticRenderFns } from "./TabBodySectionLayout.vue?vue&type=template&id=5f3f995a&scoped=true&"
import script from "./TabBodySectionLayout.vue?vue&type=script&lang=js&"
export * from "./TabBodySectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f995a",
  null
  
)

export default component.exports